import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';

@Component({
    selector: 'app-common-feature-categories-add',
    templateUrl: './common-feature-categories-add.component.html',
    styleUrls: ['./common-feature-categories-add.component.css'],
    standalone: false
})
export class CommonFeatureCategoriesAddComponent {

  @Output() saved = new EventEmitter<string>();
  @Output() cancel = new EventEmitter<void>();

  public form: UntypedFormGroup;

  constructor(private fb: UntypedFormBuilder) {
    this.form = this.fb.group({
      name: ['', Validators.required]
    });
  }

  onSave(): void {
    if (this.form.valid) {
      this.saved.emit(this.form.value.name);
    }
  }

  onCancel(): void {
    this.cancel.emit();
  }
}